module.exports = __webpack_public_path__ + "files/07c6d54570eccdaa61ac5396f3ef5d72.png";